<mat-toolbar class="subtitulo">Arquivos de Extratos Bancários</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultarExtrato="ngForm">

            <!-- Filtros de Pesquisa -->
            <div fxFlexFill fxLayout="row">
                <mat-form-field fxFlex="40">
                    <mat-label>Nome do Arquivo</mat-label>
                    <input [(ngModel)]="filtroNomeArquivo"
                           matInput
                           name="nomeArquivo"
                           placeholder="Digite o nome do arquivo">
                </mat-form-field>

                <mat-form-field fxFlex="30" fxFlexOffset="20px">
                    <mat-label>Banco</mat-label>
                    <input [(ngModel)]="filtroNumeroBanco"
                           matInput
                           name="numeroBanco"
                           placeholder="Número do banco">
                </mat-form-field>

                <mat-form-field fxFlex="30" fxFlexOffset="20px">
                    <mat-label>Conta</mat-label>
                    <input [(ngModel)]="filtroNumeroConta"
                           matInput
                           name="numeroConta"
                           placeholder="Número da conta">
                </mat-form-field>
            </div>

            <div fxFlexFill fxLayout="row">
                <mat-form-field fxFlex="30">
                    <mat-label>Data Início</mat-label>
                    <input (input)="onMascaraDataInput($event)"
                           (change)="onDataInicioChange()"
                           [(ngModel)]="filtroDataInicio"
                           [matDatepicker]="dataInicioPicker"
                           matInput
                           maxlength="10"
                           name="dataInicio"
                           placeholder="Data Início">
                    <mat-datepicker-toggle [for]="dataInicioPicker" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #dataInicioPicker></mat-datepicker>
                </mat-form-field>

                <mat-form-field fxFlex="30" fxFlexOffset="20px">
                    <mat-label>Data Fim</mat-label>
                    <input (input)="onMascaraDataInput($event)"
                           (change)="onDataFimChange()"
                           [(ngModel)]="filtroDataFim"
                           [matDatepicker]="dataFimPicker"
                           matInput
                           maxlength="10"
                           name="dataFim"
                           placeholder="Data Fim">
                    <mat-datepicker-toggle [for]="dataFimPicker" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #dataFimPicker></mat-datepicker>
                </mat-form-field>
            </div>

            <!-- Action Buttons -->
            <div class="botoes" dir="rtl" fxFlexFill fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;">
                <button (click)="abrirDialogoImportacao()" fxFlex="20%" mat-raised-button *ngIf="perfilAcesso.insere">
                    <mat-icon>cloud_upload</mat-icon>
                    IMPORTAR
                </button>
                <button (click)="consultar()" fxFlex="20%" mat-raised-button style="padding-right: 20px">
                    <mat-icon>search</mat-icon>
                    CONSULTAR
                </button>
                <button (click)="limpar()" fxFlex="20%" mat-raised-button style="padding-right: 20px">
                    <mat-icon>clear</mat-icon>
                    LIMPAR
                </button>
            </div>
        </form>

        <!-- Table -->
        <table *ngIf="mostrarTabela; else tabelaSemDados" [dataSource]="dataSource" mat-table style="margin-top: 20px">

            <!-- Nome do Arquivo -->
            <ng-container matColumnDef="nomeArquivo">
                <th *matHeaderCellDef mat-header-cell>Nome Arquivo</th>
                <td *matCellDef="let element" mat-cell>
                    <div class="file-cell">
                        <mat-icon>description</mat-icon>
                        <span>{{ element.nomeArquivo }}</span>
                    </div>
                </td>
            </ng-container>

            <!-- Banco e Conta -->
            <ng-container matColumnDef="bancoConta">
                <th *matHeaderCellDef mat-header-cell>Banco/Conta</th>
                <td *matCellDef="let element" mat-cell>
                    <div class="bank-info" *ngIf="element.contaBancaria; else fallbackBancoConta">
                        <span class="bank-number">{{ element.contaBancaria.banco.numero }}
                            - {{ element.contaBancaria.banco.nome }}</span> |
                        <span class="account-number">Ag. {{ element.contaBancaria.numeroAgencia }}
                            | C. {{ element.contaBancaria.numeroContaBancaria }}</span>
                    </div>
                    <ng-template #fallbackBancoConta>
                        <div class="bank-info">
                            <span class="bank-number">{{ element.numeroBanco || '-' }}</span> /
                            <span class="account-number">{{ element.numeroConta || '-' }}</span>
                        </div>
                    </ng-template>
                </td>
            </ng-container>

            <!-- Data Importação -->
            <ng-container matColumnDef="dataImportacao">
                <th *matHeaderCellDef mat-header-cell>Data Importação</th>
                <td *matCellDef="let element" mat-cell>
                    {{ formatarDataHora(element.dataImportacao) }}
                </td>
            </ng-container>

            <!-- Status -->
            <ng-container matColumnDef="statusGeral">
                <th *matHeaderCellDef mat-header-cell>Status</th>
                <td *matCellDef="let element" mat-cell>
                    <ng-container *ngIf="element.importadoSucesso === false">
                        <span [style.background-color]="obterCorStatusAssociacao('ERRO_IMPORTACAO')"
                              class="status-badge">Erro na Importação</span>
                    </ng-container>
                    <ng-container *ngIf="element.importadoSucesso !== false">
                        <span [style.background-color]="obterCorStatusAssociacao(element.statusAssociacao)"
                              class="status-badge">
                            {{ obterStatusAssociacaoTexto(element.statusAssociacao) }}
                        </span>
                    </ng-container>
                </td>
            </ng-container>

            <!-- Ações -->
            <ng-container matColumnDef="acoes">
                <th *matHeaderCellDef mat-header-cell>Ações</th>
                <td *matCellDef="let element" mat-cell>
                    <button (click)="abrirAssociacao(element)"
                            mat-icon-button
                            matTooltip="Associar Linhas com Categoria Contábil"
                            color="primary"
                            *ngIf="podeAssociar && element.importadoSucesso !== false">
                        <mat-icon>account_balance</mat-icon>
                    </button>
                    <button (click)="abrirPopupErroImportacao(element)"
                            mat-icon-button
                            matTooltip="Ver erro da importação"
                            color="warn"
                            *ngIf="element.importadoSucesso === false">
                        <mat-icon>error</mat-icon>
                    </button>
                    <button (click)="excluirArquivo(element)"
                            mat-icon-button
                            matTooltip="Excluir arquivo"
                            color="warn"
                            *ngIf="perfilAcesso.deleta">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
            <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
        </table>

        <div [hidden]="!mostrarTabela">
            <mat-paginator
                    (page)="onPageChange($event)"
                    [length]="totalElements"
                    [pageIndex]="currentPage"
                    [pageSizeOptions]="pageSizeOptions"
                    [pageSize]="pageSize"
                    showFirstLastButtons>
            </mat-paginator>
        </div>

        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{ msg }}
            </div>
        </ng-template>

    </div>
</div>
